const state = {
  mdValue: '',
  mdHtml: '',
  md_product_desc: '',          // 产品描述md
  html_product_desc: '',        // 产品描述html
  md_product_intro: '',         // 产品介绍md
  html_product_intro: '',       // 产品介绍html
  md_product_params: '',        // 产品参数md
  html_product_params: ''       // 产品参数html
}

const mutations = {
  SET_MDVALUE: (state, value) => {
    state.mdValue = value
  },
  SET_MDHTML: (state, value) => {
    state.mdHtml = value
  },
  // 产品描述
  set_md_product_desc: (state, value) => {
    state.md_product_desc = value
  },
  set_html_product_desc: (state, value) => {
    state.html_product_desc = value
  },
  // 产品介绍
  set_md_product_intro: (state, value) => {
    state.md_product_intro = value
  },
  set_html_product_intro: (state, value) => {
    state.html_product_intro = value
  },
  // 产品参数
  set_md_product_params: (state, value) => {
    state.md_product_params = value
  },
  set_html_product_params: (state, value) => {
    state.html_product_params = value
  }
}

const actions = {}

export default {
  state,
  mutations,
  actions
}
